<template>
  <div class="privacy-box">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PrivacyBox'
}
</script>

<style scoped>
.privacy-box {
  background-color: #f8f9fa;
  border-left: 4px solid #667eea;
  padding: 1.5rem;
  margin: 1.5rem 0;
  border-radius: 5px;
}

.privacy-box p {
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  line-height: 1.8;
  color: #333;
}

.privacy-box strong {
  color: #2a5298;
}

.privacy-box a {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
}

.privacy-box a:hover {
  color: #2a5298;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .privacy-box p {
    font-size: 1rem;
  }
}
</style>

